<template>
    <div class="page info">
        <!-- 头部 -->
        <head-bar title="开票资料" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <span @click="gotoEdit">新增</span>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <transition name="van-fade">
            <div class="content">
                <div class="invoice_list_container" v-if="invoiceList.length">
                    <div
                        class="invoice_item"
                        v-for="(item, index) in invoiceList"
                        :key="index"
                    >
                        <div class="invoice_info">
                            <div class="company_name">
                                <span>{{ item.companyName }}</span>
                                <i class="default-icon" v-if="item.isDefault"
                                    >默认</i
                                >
                            </div>
                            <div class="tax_number">
                                <span>
                                    {{ item.taxNo }}
                                </span>
                                <em class="invoice_status">
                                    {{ item.invoiceStatusDesc }}
                                </em>
                            </div>
                        </div>
                        <div class="button_group">
                            <span
                                class="edit_button button_item"
                                @click="handleEdit(item)"
                                >修改</span
                            >
                            <span
                                class="delete_button button_item"
                                @click="openViewPopup(item)"
                                >查看更多</span
                            >
                        </div>
                    </div>
                </div>
                <div v-else>
                    <empty-data
                        iconText="暂无开票资料"
                        :iconSrc="emptyIcon"
                        :paddingTop="6"
                        iconSize="slim"
                    />
                    <div class="empty-button">
                        <van-button
                            type="primary"
                            @click="gotoEdit"
                            size="large"
                            round
                        >
                            + 创建开票信息
                        </van-button>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 弹出层 -->
        <van-popup
            closeable
            close-icon-position="top-right"
            close-icon="close"
            v-model="popupShow"
        >
            <div class="view_invoice_container">
                <div class="caption">
                    <span>查看发票</span>
                </div>
                <div class="view_list">
                    <div class="view_item">
                        <div class="view_label">
                            <span>公司名称</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.companyName }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>注册地址</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.registeredAddress }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>公司电话</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.companyTel }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开户银行</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.depositBank }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>银行账户</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.bankAccount }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开票方式</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.invoiceTypeAlias }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>收货人</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.receiver }}</span>
                        </div>
                    </div>
                    <div
                        class="view_item"
                        v-if="
                            viewInvoice.mailList.length &&
                                viewInvoice.mailList[0]
                        "
                    >
                        <div class="view_label">
                            <span>电子邮箱</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.mailList[0] }}</span>
                        </div>
                    </div>
                    <div
                        class="view_item"
                        v-if="
                            viewInvoice.mailList.length &&
                                viewInvoice.mailList[1]
                        "
                    >
                        <div class="view_label">
                            <span>备用邮箱</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.mailList[0] }}</span>
                        </div>
                    </div>
                    <div
                        class="view_item"
                        v-if="
                            viewInvoice.mailList.length &&
                                viewInvoice.mailList[2]
                        "
                    >
                        <div class="view_label">
                            <span>备用邮箱</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.mailList[2] }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>手机号码</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.receiverPhone }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>收货地区</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.provinceName }}</span
                            >&nbsp; <span>{{ viewInvoice.cityName }}</span
                            >&nbsp; <span>{{ viewInvoice.countyName }}</span
                            >&nbsp;
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>详细地址</span>
                        </div>
                        <div class="view_text">
                            <span>{{ viewInvoice.detailAddress }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from "vue";
import { Field, Button, Toast, Popup } from "vant";
import HeadBar from "../../../components/HeadBar";
import EmptyData from "../../../components/EmptyData";

Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Popup);

export default {
    name: "Info",
    components: { HeadBar, EmptyData, Popup },
    data() {
        return {
            popupShow: false,
            // 空数据icon
            emptyIcon: require("../../../public/images/user/invoice/fp-null.png"),
            /* 展示表单数据 */
            viewInvoice: {
                companyName: "", // 公司名称
                taxNo: "", // 公司税号
                registeredAddress: "", // 注册地址
                companyTel: "", // 公司电话
                depositBank: "", // 开户银行
                bankAccount: "", // 银行账号
                invoiceTypeAlias: "", // 开票方式
                mailList: [], //电子邮箱
                receiver: "", // 收票人
                receiverPhone: "", // 手机号码
                /* 省市区编码和名称 */
                provinceCode: "",
                provinceName: "",
                cityCode: "",
                cityName: "",
                countyCode: "",
                countyName: "",
                detailAddress: "", // 详细地址
            },
            //发票列表
            invoiceList: [],
        };
    },
    created() {
        this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            const url = this.$api.userApi.queryInvoiceList;
            this.$axios
                .post(url, {})
                .then((res) => {
                    let { data: invoiceList = [] } = res;
                    this.invoiceList = invoiceList;
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        /* 修改开票信息 */
        handleEdit(invoiceInfo = {}) {
            let { invoiceId } = invoiceInfo;
            this.$router.push({
                path: "/user/invoice/infoEdit",
                query: {
                    id: invoiceId,
                },
            });
        },
        /** 新增发票 */
        gotoEdit() {
            this.$router.push({
                path: "/user/invoice/infoEdit",
            });
        },
        /**
         * @description 打开弹窗展示
         */
        openViewPopup(invoiceInfo = {}) {
            this.viewInvoice = Object.assign(this.viewInvoice, invoiceInfo);
            this.popupShow = true;
        },
    },
};
</script>

<style lang="less" scoped>
.info {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            display: inline-block;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .content {
        padding-top: 20px;

        .invoice_list_container {
            width: 750px;
            .invoice_item {
                margin-bottom: 20px;
                padding: 0 25px;
                width: 700px;
                background-color: #fff;
                .invoice_info {
                    padding: 45px 0px;
                    font-size: 32px;
                    border-bottom: 1px solid #f6f6f6;
                    .company_name {
                        padding: 0 0 22px 0;
                        .default-icon {
                            *display: inline;
                            display: inline-block;
                            margin-left: 20px;
                            padding: 2px 10px;
                            background-color: #6ab0f7;
                            font-size: 12px;
                            color: #fff;
                            font-style: normal;
                        }
                    }
                    .tax_number {
                        color: #999;
                        > .invoice_status {
                            padding-left: 15px;
                        }
                    }
                }

                .button_group {
                    padding: 40px 0;
                    text-align: right;
                    .edit_button {
                        margin-right: 30px;
                    }
                    .button_item {
                        *display: inline;
                        display: inline-block;
                        height: 54px;
                        padding: 0 20px;
                        border-radius: 30px;
                        border: 1px solid #dedede;
                        font-size: 24px;
                        line-height: 54px;
                    }
                }
            }
        }

        .empty-button {
            padding: 60px 166px;
        }
    }
}
.view_invoice_container {
    width: 710px;
    padding: 0 0 20px 0;
    > .caption {
        height: 110px;
        font-size: 32px;
        line-height: 110px;
        text-align: center;
    }
    .view_list {
        width: 710px;
        .view_item {
            overflow: hidden;
            margin: 0 auto;
            padding-bottom: 30px;
            width: 630px;
            .view_label {
                float: left;
                width: 155px;
                font-size: 32px;
                color: #999;
            }
            .view_text {
                float: right;
                width: 470px;
                font-size: 32px;
                color: #333;
            }
        }
    }
}
</style>
